<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="100px">
				<el-form-item label="分类类型：" style="margin-bottom:10px" prop="cate_type">
					<el-radio-group v-model="form.cate_type" @input='radioInput'>
						<el-radio :label="1">商品分类</el-radio>
						<el-radio :label="3">商品品牌</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="一级分类：" prop="cate_pid">
					<el-select class="select" v-model="form.cate_pid" clearable placeholder="一级分类">
						<el-option v-for="item in cateList" :key="item.cate_id" :label="item.cate_name"
							:value="item.cate_id" />
					</el-select>
				</el-form-item>
				<el-form-item label="分类名称：" prop="cate_name">
					<el-input class="input" v-model="form.cate_name" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="分类图标：" prop="cate_icon" style="margin-bottom: 0;">
					<div class="row">
						<multiUpload :type='0' :limitImg='1' :noneBtnImg='iconList.length > 0' :fileList="iconList" @saveImg="saveImg" @delImg="delImg"/>
						<span class="span">请上传图片(200-200px)</span>
					</div>
				</el-form-item>
				<el-form-item label="显示顺序：" prop="sort">
					<el-input class="input" v-model="form.sort" placeholder="请输入内容" />
					<span class="span">数值越小越靠前</span>
				</el-form-item>
				<el-form-item v-if="form.cate_pid != ''" label="三级标签：" prop="tags">
					<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
						size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
					</el-input>
					<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>
					<el-tag :key="tag" v-for="tag in form.tags" closable :disable-transitions="false"
						@close="handleClose(tag)">
						{{tag}}
					</el-tag>
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		goodsCateAdd,
		goodsCateEdit,
		goodsCateLists,
		goodsCateDetail
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			multiUpload
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '编辑新增',
				iconList:[],//分类图标
				cateList: [],
				form: {
					cate_type: 1, //分类类型(1=商品分类,3=品牌分类)
					cate_pid: '', //一级分类id
					cate_name: '', //分类名称
					cate_icon: '', //分类图标
					sort: '', //显示顺序
					tags: [] //三级标签
				},
				inputValue: '',
				inputVisible: false
			}
		},
		mounted() {
			if (this.type != -1) {
				//详情编辑
				this.form.cate_id = this.type;
				this.getGoodsCateDetail();
			}else{
				this.getGoodsCateList();
			}
		},
		methods: {
			
			//获取分类详情
			getGoodsCateDetail(){
				goodsCateDetail({cate_id:this.form.cate_id}).then(res=>{
					if(res.code == 0){
						if(res.data.cate_icon != ''){
							this.iconList.push({url:res.data.cate_icon})
						}
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
						this.getGoodsCateList();
					}
				}).catch(err=>{})
			},
			
			//切换分类类型
			radioInput(){
				this.form.cate_pid = '';
				this.getGoodsCateList();
			},
			
			//获取分类列表
			getGoodsCateList() {
				goodsCateLists({
					cate_type: this.form.cate_type
				}).then(res => {
					if (res.code == 0) {
						this.cateList = res.data;
					}
				}).catch(err => {})
			},

			handleClose(tag) {
				this.form.tags.splice(this.form.tags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.form.tags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			
			//图片存储
			saveImg(arr){
				this.form.cate_icon = arr[0];
			},
			
			//图片删除
			delImg(arr){
				this.form.cate_icon = '';
				this.iconList = []
			},

			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						if (this.type != -1) {
							//编辑
							goodsCateEdit({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.iconList = []
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						} else {
							//新增
							goodsCateAdd({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.iconList = []
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						}
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
		padding: 20px 20px 0 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 644px;
		min-height: 100%;
		padding-bottom: 66px;
	}


	.input {
		width: 200px;
		margin-right: 20px;
	}

	.select {
		width: 175px;
		margin-right: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '※';
		color: #EA0000;
		font-size: 12px;
		margin-right: 4px;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100px;
		height: 100px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 20px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-right: 10px;
		height: 32px;
		line-height: 32px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-right: 10px;
		vertical-align: bottom;
	}
</style>